import React, { Component } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { Alert } from '@material-ui/lab';

class NoDataBar extends Component { 

    constructor(props){
        super(props)
        this.state = {
            fontSize:""
        }
    }

    componentWillMount=()=>{
        this.handleResize()
        window.addEventListener('resize', this.handleResize)
      }
    
    handleResize=()=>{
        //レスポンシブデザイン
        if(window.innerWidth > 1024){
            this.setState(
                {fontSize:"30px"}
            )
        }else if(window.innerWidth <= 1024){
            this.setState(
                {fontSize:"45px"}
            )
        }
    }

    render(){
        return(
            <div>
                <Snackbar
                    anchorOrigin={{vertical:"center", horizontal:"center"}}
                    open={this.props.open}
                    onClose={this.props.handleClose}
                    key="noDataBar"
                    style={{marginTop:"200px"}}
                >
                    <Alert onClose={this.props.handleClose} severity="info">
                        <text style={{fontSize:this.state.fontSize}}>{this.props.message}</text>
                    </Alert>
                </Snackbar>
            </div>
        )
    }
}

export default NoDataBar;